<template>
  <div>
    <span v-if="editable"
        class="attribute-table-action">
      <el-dropdown @command="onAction">
        <el-button size="small">
          アクション
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="add">
            行追加
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>
    <div class="base-table-list attribute-table">
      <div class="el-table el-table--fit el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition">
        <div class="el-table__header-wrapper">
          <table class="el-table__body">
            <tr>
              <th><div class="cell">キー</div></th>
              <th><div class="cell">値</div></th>
              <th class="gutter"
                  style="width: 0px; display: none;">
                <div class="cell">値</div>
              </th>
            </tr>
          </table>
        </div>
        <div class="el-table__body-wrapper">
          <table class="el-table__body">
            <template v-for="(value, index) in filteredValues">
              <tr :key="index"
                  class="el-table__row">
                <td>
                  <BaseCell
                      :properties="keyProperty"
                      :display-item="value"
                      :editable="editable"
                      class="inner-cell" />
                </td>
                <td>
                  <BaseCell
                      v-if="showValue(value)"
                      :properties="valueProperty(value)"
                      :display-item="value"
                      :editable="editableValue(value)"
                      :class="'inner-cell ' + (valueProperty(value).class || '')" />
                </td>
              </tr>
            </template>
          </table>
          <div v-if="filteredValues.length === 0"
              class="el-table__empty-block"
              style="width: 960px;">
            <span class="el-table__empty-text">データなし</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.attribute-table-action {
  float: right;
  margin: 10px 20px 0 0;
}
 .el-table {
  box-shadow: none;
  height: 350px;
  display: flex;
  flex-direction: column;
}

.attribute-table .el-table table {
  border-collapse: collapse;
  width: 100%;
}

.attribute-table .el-table__header-wrapper {
  border-bottom-color: rgb(199, 211, 217);
  border-bottom-style: solid;
  border-bottom-width: 1px ;
}

.attribute-table .el-table__header-wrapper th {
  border-bottom-style: none;
}

.attribute-table .el-table__body-wrapper {
  flex-grow: 1;
}

.attribute-table .el-table table th,
.attribute-table .el-table table td {
  width: 100px;
}

.attribute-table .inner-cell ::v-deep input,
.attribute-table .inner-cell ::v-deep i {
  height: 24px;
  line-height: 24px;
  width: 100%;
}

.attribute-table .inner-cell {
  padding-right: 10px;
  padding-left: 10px;
  line-height: 24px;
}
</style>

<script>
import _ from 'lodash'

import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import utilAttribute from '@/utils/attribute'

const EDITABLE = { attrId: true, attrValue: true }

export default {
  name: 'AttributeTable',
  components: {
    BaseCell
  },
  props: {
    keys: {
      type: Array,
      default: () => ([])
    },
    values: {
      type: Array,
      default: () => ([])
    },
    editable: {
      type: Boolean,
      default: false
    },
    height: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    keyProperty () {
      return {
        type: 'String', path: 'attrId', elementType: ELEMENT_TYPE.SELECT_BOX,
        selectCode: this.attributeKeyList,
        codeName: (selected) => {
          return _.chain(this.keys)
            .find(val => val.id === selected)
            .thru(val => val == null ? selected : `${val.label} : ${val.id}`)
            .value()
        },
        change: this.keyChange,
        editableId: 'attrId', editableCondition: this.editableCondition
      }
    },
    tableSetList () {
      return [
        {
          type: 'String', label: 'キー', path: 'attrId', elementType: ELEMENT_TYPE.SELECT_BOX,
          selectCode: this.attributeKeyList,
          codeName: (selected) => {
            return _.chain(this.keys)
              .find(val => val.id === selected)
              .thru(val => val == null ? selected : `${val.label} : ${val.id}`)
              .value()
          },
          editableId: 'attrId', editableCondition: this.editableCondition
        },
        {
          type: 'String', label: '値', path: 'attrValue',
          editableId: 'attrId', elementType: ELEMENT_TYPE.INPUT
        }
      ]
    },
    editableObj () {
      return this.editable ? EDITABLE : {}
    },
    filteredValues () {
      return _.filter(this.values, val => {
        return _.find(this.keys, key => key.id === val.attrId || val.new)
      })
    }
  },
  methods: {
    attributeKeyList (row) {
      const registeredKey = _.map(this.values, 'attrId')
      return _.chain(this.keys)
        .filter(val => val.editable && (row.attrId === val.id || !_.includes(registeredKey, val.id)))
        .map(val => ({ code: val.id, name: `${val.label} : ${val.id}` }))
        .value()
    },
    onAction (command) {
      this.values.push({ new: true, attrId: null, attrValue: '' })
    },
    editableCondition (row) {
      return _.get(row, 'new', false)
    },
    keyChange (key, oldKey) {
      const attr = this.values.find((data) => data.attrId === oldKey)
      _.set(attr, 'attrValue', null)
    },
    showValue (row) {
      return Boolean(row.attrId)
    },
    editableValue (row) {
      const attr = this.keys.find((data) => data.id === row.attrId)
      return Boolean(attr.editable) && this.editable
    },
    valueProperty (row) {
      const attr = this.keys.find((data) => data.id === row.attrId)
      return utilAttribute.getCustomizeColumn(row, attr.inputType,
        row.attrId, attr.editable)
    }
  }
}
</script>
